"use client"
/* */
import { jsx } from 'react/jsx-runtime';
import 'invariant';
import 'luxon';
import 'react-aria-components';
import { EmptyView } from '../../views/EmptyView/EmptyView.mjs';
import clsx from 'clsx';
import 'react';
import '@mittwald/react-tunnel';
import '../../../../lib/viewComponentContext/viewComponentContext.mjs';
import '../../../../lib/propsContext/propsContext.mjs';
import '../../../../lib/slotContext/slotContext.mjs';
import '@react-aria/utils';
import 'remeda';
import 'dot-prop';
import 'react-aria';
import '@tabler/icons-react';
import '../../../Icon/Icon.mjs';
import '../../../Button/Button.mjs';
import '../../../ContextMenu/ContextMenu.mjs';
import '../../../MenuItem/MenuItem.mjs';
import '../../../ContextMenu/components/ContextMenuTrigger/ContextMenuTrigger.mjs';
import '../../../ContextMenu/components/ContextMenuSection/ContextMenuSection.mjs';
import '../../../ColumnLayout/ColumnLayout.mjs';
import '../ListSummary/ListSummary.mjs';
import { useList } from '../../hooks/useList.mjs';
import '../../List.mjs';
import { Item } from './components/Item/Item.mjs';
import DivView from '../../../../views/DivView.mjs';
import ItemsGridListView from '../../../../views/ItemsGridListView.mjs';
import styles from './Items.module.scss.mjs';
import { FallbackItems } from './components/FallbackItems/FallbackItems.mjs';

const Items = () => {
  const list = useList();
  const tiles = list.viewMode === "tiles";
  const isLoading = list.loader.useIsLoading();
  const isInitiallyLoading = list.loader.useIsInitiallyLoading();
  if (!list.itemView) {
    return null;
  }
  const items = list.items.entries.map((item) => /* @__PURE__ */ jsx(Item, { data: item.data, id: item.id }, item.id));
  const rootClassName = clsx(
    styles.items,
    isLoading && styles.isLoading,
    tiles && styles.tiles
  );
  return /* @__PURE__ */ jsx(DivView, { "aria-hidden": isInitiallyLoading, "aria-busy": isLoading, children: /* @__PURE__ */ jsx(
    ItemsGridListView,
    {
      className: rootClassName,
      ...list.componentProps,
      renderEmptyState: () => /* @__PURE__ */ jsx(EmptyView, {}),
      style: {
        gridTemplateColumns: `repeat(auto-fill, minmax(${list.itemView.tileMaxWidth}px, 1fr))`
      },
      layout: list.viewMode === "tiles" ? "grid" : "stack",
      children: isInitiallyLoading ? /* @__PURE__ */ jsx(FallbackItems, {}) : items
    }
  ) });
};

export { Items, Items as default };
//# sourceMappingURL=Items.mjs.map
